  // 移动端首页tab点击向前滚动
  $(function(){
    if(window.screen.width < 1024){
          let tabs = $('.template-index .section-collection-tabs .collection-tabs__list-link');
          tabs.click(function(index){
            let checkdIndex = $(".collection-tabs__list-link.active").index();    // 当前选中的index
            let like = 160;                 // 每次移动
            let num = $(this).index();      // 点击 索引
            let total = tabs.length * like; // 总长度限制
            console.log((num * like),(total - like*1.5))
            if(checkdIndex > num){               // 当前默认选中项 大于当前点击想 就说明点击了前一项，
                console.log('you')
                if((num * like) <= (total - like*1.5) ){       // you移
                  $( ".template-index .section-collection-tabs .collection-tabs__list" ).animate({ "left": `-${(num * like) - like}px` }, "slow" );
                }
            }else{                              // 当前默认选中项 大于当前点击想 就说明点击了前后项，
                console.log('zuo')
                if((num * like) < (total - like*1.5) ){       // 左移
                  $( ".template-index .section-collection-tabs .collection-tabs__list" ).animate({ "left": `-${num * like}px` }, "slow" );
                }
            }
          })
    }
  })

  // 首页视频播放按钮
  $(".template-index .background-video .background-video__fallback-img").append("<div class='videoPlayButton'></div>")
  
  // 首页视频播放按钮点击
  $(".template-index .background-video .background-video__fallback-img .videoPlayButton").click(function(){
    $(".template-index .background-video .background-video__iframe").css("z-index","999999999")
    $(".template-index .background-video .background-video__fallback-img .videoPlayButton").fadeOut()
    $(".template-index .background-video .background-video__iframe iframe").before(`<div class='closeVideoButton'></div>`)
    if(window.screen.width > 1024){
      $(".template-index .background-video .background-video__iframe iframe,.template-index .background-video .background-video__iframe").css("top","28%")
    }else{
      $(".template-index .background-video .background-video__iframe iframe,.template-index .background-video .background-video__iframe").css({"top":"30%","left":"3%","width":"94%","height":"30%"})
    }
  });
  
  // 首页视频关闭按钮点击
  $(document).on('click','.template-index .closeVideoButton',function (){
    $(".template-index .background-video .background-video__iframe iframe,.template-index .background-video .background-video__iframe").css("top","-100%")
    $(".template-index .background-video .background-video__fallback-img .videoPlayButton").fadeIn()
  });
 
  // 产品页导航点击锚点
  $(".productAddNav li").click(function(){
    let index = $(this).index()
    // 点击给当前项添加样式
    $(this).addClass("active").siblings().removeClass("active")
    // index为0表示点击第一个，以此类推
    if(index == 0){
      if(window.screen.width > 1024){
        $('html,body').animate({scrollTop:$('.product-information').offset().top-110}, 200);
      }else{
        $('html,body').animate({scrollTop:$('.product-information').offset().top+40}, 200);
      }
    }else if(index == 1){
      if(window.screen.width > 1024){
        $('html,body').animate({scrollTop:$('.cs_videoTable').offset().top-180}, 200);
      }else{
        $('html,body').animate({scrollTop:$('.cs_videoTable').offset().top-120}, 200);
      }
    }else if(index == 2){
      if(window.screen.width > 1024){
        $('html,body').animate({scrollTop:$('.specs').offset().top-130}, 200);
      }else{
        $('html,body').animate({scrollTop:$('.specs').offset().top-80}, 200);
      }
    }/*else if(index == 3){
      if(window.screen.width > 1024){
        $('html,body').animate({scrollTop:$('#shopify-section-template--15770338263233__product-recommendations').offset().top-110}, 200);
      }else{
        $('html,body').animate({scrollTop:$('#shopify-section-template--15770338263233__product-recommendations').offset().top-80}, 200);
      }
    }*/
  });
  
  
 // 产品页描述超出 Lenrn More
 // $('.product-information ul').after(`<p class="productLearnMore">Learn More<img src="https://cdn.shopifycdn.net/s/files/1/0047/0247/0190/files/learnMoreArrow_03.jpg?v=1659682515"/></p>`)
  $('.cs-product-title-highlight_list').after(`<p class="productLearnMore">Learn More<img src="https://cdn.shopifycdn.net/s/files/1/0047/0247/0190/files/learnMoreArrow_03.jpg?v=1659682515"/></p>`)
// 产品页描述 Lenrn More 点击
  $(document).on('click','.productLearnMore',function (){
    $(this).html("Learn Less<img src='https://cdn.shopifycdn.net/s/files/1/0047/0247/0190/files/learnMoreArrow_03.jpg?v=1659682515'/>").addClass("productLearnLess")
    $(".product-information ul").css({"overflow":"auto","height":"100%","margin-bottom":"16px",})
  });
  // 产品页描述 Lenrn Less 点击
   $(document).on('click','.productLearnLess',function (){
    $(this).html("Lenrn More<img src='https://cdn.shopifycdn.net/s/files/1/0047/0247/0190/files/learnMoreArrow_03.jpg?v=1659682515'/>").removeClass("productLearnLess")
    $(".product-information ul").css({"overflow":"hidden","height":"105px","margin-bottom":"0",})
     if(window.screen.width > 1024){
       $('html,body').animate({scrollTop:$('#main-content').offset().top}, 100);
     }else{
       $('html,body').animate({scrollTop:$('#ProductInfo-template--15770338263233__main-product').offset().top+20}, 100);
     }
  });


  // 产品页关闭放大弹框 svg 样式
  $(".thb-product-detail .product-single__media-zoom").click(function(){
    $(".pswp__button.pswp__button--close svg path").css("stroke","#000")
    $(".pswp__button.pswp__button--close").mouseover(function(){
      $(".pswp__button.pswp__button--close svg path").css("stroke","#fff")
    })
    $(".pswp__button.pswp__button--close").mouseout(function(){
      $(".pswp__button.pswp__button--close svg path").css("stroke","#000")
    })
  })

  // 产品页锚点根据元素位置添加选中样式
  setTimeout(()=>{
    $(".product-information,.cs_videoTable,.specs").addClass("productScroll")
  },1000)
  $(window).scroll(function(event){
    checkscroll()
  });
  function checkscroll(){
    let sections = $(".productScroll"); 
    var s_num = sections.length;
    sections.each(function(index,el){
        let _this = $(this);
        if( _this.offset().top <  $(document).scrollTop() + 400 ){
            $(".cs-product_ .productAddNav li").removeClass("active").eq(index).addClass("active");
        }
    });
  }

  //  产品页视频 tab
  $(".cs_videoList li").click(function(){
      let index = $(this).index()
      $(this).parents(".cs_videoList").find('li').removeClass("cs_videoListActive") //所有标题清除激活样式
      $(this).addClass("cs_videoListActive") // 给当前标题添加激活样式
      $(this).parents(".cs_videoList").siblings(".cs_videoContent").find('li').removeClass("cs_videoContentActive") 
      $(this).parents(".cs_videoList").siblings(".cs_videoContent").find('li').eq(index-1).addClass("cs_videoContentActive")
  })
  // 移动端产品tab视频点击打开
  $(document).on('click','.cs_videoList li',function (){
    let index = $(this).index()
    $(".cs_videoContent").css("top","0")
  });
  // 移动端产品tab视频关闭按钮点击
  $(document).on('click','.cs_videoContent li .closeVideoButton',function (){
    $(".cs_videoContent").css("top","-100%")
  });

  // collection page 根据 url 给对应栏目添加 active
  let testIndex = window.location.href.lastIndexOf("/"); //获取url最后一个 / 位置索引
  let test = window.location.href.slice(testIndex+1); //获取最后一个 / 后的字符串
  console.log(test,'test')
  $(".cs-collection-meun-list a").each(function(i,val){ //遍历页面对应模块list，i为索引，val为dom元素
    $(this).parent(".cs-collection-meun-list").removeClass("active") //清空所有active
    let menuListText = val.href.slice(val.href.lastIndexOf("/")+1)
    console.log(menuListText)
    if(menuListText.search(test) !== -1 && menuListText.search("#") == -1){
      console.log($(this))
      $(this).parent(".cs-collection-meun-list").addClass("active") //给当前元素添加 active
    }
  });